import React, {Component} from 'react';
import {SortableElement} from 'react-sortable-hoc';
import PropTypes from "prop-types";
import moment from 'moment';

class SortableQuizQuestion extends Component {

    render(){
        const options = [
            {letter: 'A', number: 1},
            {letter: 'B', number: 2},
            {letter: 'C', number: 3},
            {letter: 'D', number: 4},
        ]
        return (
            <div
                key={this.props.index}
                className="video-question sp-10 border-bottom"
            >
                <div className="row">
                    <div className="col-sm-10">
                        {this.props.number + 1}. &nbsp;
                        <span dangerouslySetInnerHTML={{__html: this.props.question.question}}></span>
                        
                        {/*
                        <p>
                            <b>{this.props.number + 1}. {typeof(this.props.question.question) === 'object' ? 
                            draftToHtml(convertToRaw(this.props.question.question))
                            : this.props.question.question
                        }</b>
                        </p>
                    */}
                        <div className="row">
                            {options.map((option, i) => {
                                return (
                                    <div className="col-sm-6" key={i}>
                                        <p className={`${this.props.question.correctOption === i + 1 && "text-orange quiz-correct-option"}`} dangerouslySetInnerHTML={{__html: this.props.question["option" + option.letter]}}>
                                            
                                        </p>
                                    </div>
                                )
                            })}
                            
                        </div>
                        {!this.props.uploadQuestions &&
                            <div className="row-actions">
                                <a
                                    onClick={() => this.props.handleEditQuestionClick(this.props.question.id)}
                                    href="#EditVideoQuestionModal"
                                    data-toggle="modal"
                                >
                                    <i className="zmdi zmdi-edit"/>
                                    Edit
                                </a>
                                <a
                                    onClick={(e) => this.props.handleDeleteModalShowState(this.props.question.id, e)}
                                >
                                    <i className="zmdi zmdi-delete"/>
                                    Remove
                                </a>
                            </div>
                        }
                    </div>
                    <div className="col-sm-2">
                        {!this.props.uploadQuestions &&
                            <a onClick={() => (!this.props.isEditedInPreview && this.props.handleRewindTo(this.props.question.timeInVideo))}>
                                {moment(this.props.question.timeInVideo*1000).format('mm:ss')}
                            </a>
                        }
                    </div>
                </div>
            </div>
        )

    }
}

export default SortableElement(SortableQuizQuestion);


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/SortableQuizQuestion.js